<template>
  <l-popup :options="{permanent: true, interactive: true}" class="popup">
    <h5 class="text-center">
      Voyage Details
    </h5>

    <div v-for="section in sections" class="details-row">
      <div>{{ section.title }}:</div>
      <div>{{ getFormattedValue(section) }}</div>
    </div>
  </l-popup>
</template>

<script>
import getNested from 'lodash-es/get'
import moment from 'moment'
import {
  LPopup,
} from 'vue2-leaflet'

const defaultSections = [
  {title: 'Vessel', fieldName: 'vesselName', format: 'text'},
  {title: 'Imo', fieldName: 'imo', format: 'text'},
  {title: 'Segment', fieldName: 'segment', format: 'text'},
  {title: 'Commodity', fieldName: 'commodityGroup', format: 'text'},
  {title: 'Nautical miles', fieldName: 'nauticalMiles', format: 'float'},
  {title: 'Start date', fieldName: 'startTimestamp', format: 'datetime'},
  {title: 'End date', fieldName: 'endTimestamp', format: 'datetime'},
];


export default {
  name: 'vessel-map-popup',

  components: {
    'l-popup': LPopup,
  },

  props: {
    voyage: {
      type: Object,
      default: () => ({}),
    },

    sections: {
      type: Array,
      default: () => defaultSections,
    },
  },

  methods: {
    getNested: getNested,

    getFormattedValue(section) {
      if(section.format === 'float') {
        return getNested(this.voyage, section.fieldName, 0.0).toFixed(2);
      }
      if (section.format === 'datetime') {
        return this.formatDate(
          getNested(this.voyage, section.fieldName, null)
        );
      }

      return getNested(this.voyage, section.fieldName, '--');
    },

    formatDate(dateString) {
      if(dateString) {
        return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '--';
      }
    },

    // handleReady(evt) {
    //   this.$emit('ready', evt, this.vessel);
    //   evt._source.on('popupopen', this.handleOpen);
    //   evt._source.on('popupclose', this.handleClose);
    // },
    //
    // handleOpen(evt) {
    //   this.$emit('open', evt, this.vessel);
    // },
    //
    // handleClose(evt) {
    //   this.$emit('close', evt, this.vessel);
    // },
  },

  computed: {}
}
</script>

<style scoped lang="scss">
  .popup {
    padding-bottom: 5px;
  }

  .details-link {
    font-size: 15px;
  }

  .details-row {
    margin-top: 5px;
    min-width: 200px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted gray;
  }
</style>
